var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconStatusIneligible = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.035 2.707c.338.19.616.468.806.805l8.269 14.7a2.112 2.112 0 0 1-1.841 3.148H3.73a2.112 2.112 0 0 1-1.84-3.147l8.268-14.7a2.112 2.112 0 0 1 2.876-.806zM12 16.053c-.634 0-1.148.514-1.148 1.148v.131a1.148 1.148 0 0 0 2.296 0v-.131c0-.634-.514-1.148-1.148-1.148zm0-8.373-.078.002a1.24 1.24 0 0 0-1.159 1.315l.322 5.105a.917.917 0 0 0 1.83 0l.322-5.105A1.24 1.24 0 0 0 12 7.68z",
    fill: "#02607F"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconStatusIneligible);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-status-ineligible.31836e46005925abd4ad3d2125f4622a.svg";